<script setup lang="ts">
import EventusHeader from "../../../assets/image/eventUs/eventUs-header.jpg";
import IconEventUs from "../../../assets/icons/icon-event-us.svg";
import { useTranslate } from "addeus-common-library/stores/translate";
import ImageHeader from "../../../components/website/ImageHeader.vue";
import BlockHoverAnimated from "../../../components/website/BlockHoverAnimated.vue";
import Footer from "../../../components/website/Footer.vue";
import { useSeoMeta } from "../../../composables/useSeoMeta";

const { setTranslateNamespace } = useTranslate();
setTranslateNamespace(".eventUs");

useSeoMeta({
    title: "Événements karting entreprise, étudiants, associations",
    description:
        "Organisez vos événements karting chez Speed2Max : séminaire et team building entreprise, soirées étudiantes Student Karty, journées associatives Racing 1901. Piste privatisée, zéro émission.",
    path: "/event-us",
    breadcrumbs: [
        { name: "Accueil", path: "/" },
        { name: "Événements chez nous", path: "/event-us" },
    ],
});
</script>

<template>
    <VFlex flex-direction="column">
        <ImageHeader>
            <template #image>
                <img
                    :src="EventusHeader"
                    alt="Événements karting entreprise, étudiants et associations chez Speed2Max" />
            </template>
            <template #title>
                <div><Translate path=".titleP1"></Translate>&nbsp;</div>
                <div class="has-text-primary">
                    <Translate path=".titleP2"></Translate>
                </div>
            </template>
            <template #subtitle>
                <Translate path=".subtitle"></Translate>
            </template>
            <template #icon>
                <img :src="IconEventUs" alt="Icône événements chez Speed2Max" />
            </template>
        </ImageHeader>
        <TranslateNamespace path=".nav">
            <VFlex
                column-gap="1rem"
                row-gap="1rem"
                class="has-background-dark p-6 flex-card-anchor-2">
                <TranslateNamespace path=".enterprise">
                    <BlockHoverAnimated to="/event-us/enterprise">
                        <!-- <template #image>
                            <img src="/images/kart/faireDuKart/anchor-1.jpg" alt="Kart" />
                        </template> -->
                        <template #title>
                            <Translate path=".title"></Translate>
                        </template>
                        <template #subtitle>
                            <Translate path=".subtitle"></Translate>
                        </template>
                        <template #content>
                            <Translate path=".content"></Translate>
                        </template>
                    </BlockHoverAnimated>
                </TranslateNamespace>
                <TranslateNamespace path=".association">
                    <BlockHoverAnimated to="/event-us/association">
                        <!-- <template #image>
                            <img src="/images/kart/faireDuKart/anchor-1.jpg" alt="Kart" />
                        </template> -->
                        <template #title>
                            <Translate path=".title"></Translate>
                        </template>
                        <template #subtitle>
                            <Translate path=".subtitle"></Translate>
                        </template>
                        <template #content>
                            <Translate path=".content"></Translate>
                        </template>
                    </BlockHoverAnimated>
                </TranslateNamespace>
                <TranslateNamespace path=".student">
                    <BlockHoverAnimated to="/event-us/student">
                        <!-- <template #image>
                            <img src="/images/kart/faireDuKart/anchor-1.jpg" alt="Kart" />
                        </template> -->
                        <template #title>
                            <Translate path=".title"></Translate>
                        </template>
                        <template #subtitle>
                            <Translate path=".subtitle"></Translate>
                        </template>
                        <template #content>
                            <Translate path=".content"></Translate>
                        </template>
                    </BlockHoverAnimated>
                </TranslateNamespace>
            </VFlex>
        </TranslateNamespace>
        <Footer></Footer>
    </VFlex>
</template>

<style lang="scss">
.flex-card-anchor-2 {
    display: grid !important;
}

.card-anchor {
    &:nth-child(1) {
        &::before {
            background-image: url("../../../assets/image/eventUs/eventUs-enterprise.jpg");
        }
    }

    &:nth-child(2) {
        &::before {
            background-image: url("../../../assets/image/eventUs/eventUs-association.jpg");
        }
    }

    &:nth-child(3) {
        &::before {
            background-image: url("../../../assets/image/eventUs/eventUs-student.jpg");
        }
    }
}

@media (min-width: 790px) {
    .flex-card-anchor-2 {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 1300px) {
    .flex-card-anchor-2 {
        grid-template-columns: repeat(3, 1fr);
    }

    .card-anchor {
        min-height: 450px;
    }
}
</style>
